<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
  export default {
    name: "App",
    data: () => ({

    }),
    mounted(){
      window.addEventListener('hashchange',()=>{
        var currentPath = window.location.hash.slice(1); // 获取输入的路由

        if(this.$router.path !== currentPath){
          this.$router.push(currentPath); // 动态跳转

        }

      },false);

    }
  };
</script>
<style scoped>

</style>
<style>
  .v-application--wrap{
    width: 100% !important;
  }
  .el-main{
    background: #fff !important;
  }
  @media screen and (max-width: 750px) {
    .el-message-box {
      width: 60% !important;
    }
  }
</style>
